<form
  [formGroup]="form"
  *transloco="let fieldTranslation; read: 'field-types'"
>
  <div class="flex flex-col space-y-4 w-full">
    <mat-form-field class="fuse-mat-no-subscript w-full">
      <mat-label>{{ fieldTranslation("Placeholder") }}</mat-label>
      <input
        [placeholder]="fieldTranslation('Placeholder')"
        formControlName="placeholder"
        autocomplete="off"
        matInput
      />
    </mat-form-field>
  </div>
</form>
